export default {
  data() {
    return {
      currentPage: 1
    };
  },
  methods: {
    listSearchEvn(val) {
      // let reg = /^[\d]*$/;
      // console.log(reg.test(val))
      if (this.$route.name === "orgList") {
        this.clearArea();
      }
      this.params.text = val;
      if (!this.params.text) delete this.params.text;
      this.getList();
    },

    getPageNum(val) {
      this.currentPage = val;
      this.params.offset = (val - 1) * this.params.limit;
      this.getList();
    },

    tableHandle(obj) {
      switch (obj.type) {
        case this.$t("commonMsg.checkDetails"):
          this.toDetails(obj.data);
          break;
        case this.$t("commonMsg.edit"):
          this.edit(obj.data);
          break;
        case this.$t("commonMsg.recovery"):
          this.recovery(obj.data);
          break;
        case this.$t("commonMsg.release"):
          this.publish(obj.data);
          break;
        case this.$t("commonMsg.cancelRelease"):
          this.publish(obj.data);
          break;
        case this.$t("commonMsg.add"):
          this.add(obj.data);
          break;
        case this.$t("commonMsg.move"):
          this.move(obj.data);
          break;
        case this.$t("commonMsg.del"):
          this.del(obj.data);
          break;
        case this.$t("commonMsg.remove"):
          this.del(obj.data);
          break;
        case this.$t("sale.gift.handle"):
          this.toGiftHistory(obj.data);
          break;
        default:
          break;
      }
    },

    tableSort(obj) {
      switch (obj.type) {
        case "up":
          this.upSort(obj.data);
          break;
        case "down":
          this.downSort(obj.data);
          break;
        default:
          break;
      }
    }
  },
  mounted() {
    this.getList();
  }
};
